var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortTerm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 351,
    viewBox: "0 0 300 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.967 322.136C122.981 320.984 121.014 319.792 119.047 318.541C117.08 317.289 115.093 315.998 113.166 314.628",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.04 309.206H228.02",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.967 322.136C154.331 338.502 182.384 344.46 208.391 329.425",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1463 48.3633C9.79535 68.503 6.51721 114.364 12.0006 149.975C22.1927 212.897 60.9543 277.666 113.166 314.609",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8359 29.9316H75.8757",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.108 51.8789H134.088",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.723 56.7643C113.704 49.8524 100.79 44.4302 87.1407 42.0865C82.4519 41.2722 77.7234 40.875 72.995 40.9346C72.995 40.9346 72.9552 40.9346 72.9354 40.9346C62.8228 41.0339 52.6506 43.4768 43.8691 48.5217",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8359 29.9316H75.8757",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1466 48.3633C43.8685 48.5222 43.6102 48.6612 43.332 48.8201",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5098 37.9961C65.3442 22.0075 99.6157 31.4616 125.761 46.7352",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.635 340.608C206.94 344.54 199.529 347.122 191.841 348.294C78.6553 361.204 -44.6824 150.611 17.8606 56.1095C23.0659 48.6813 29.9004 42.3454 37.7679 37.8368L86.801 9.37507C109.39 -3.75348 140.662 -1.90634 175.192 18.0347",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.722 56.7644C189.497 93.5681 241.053 182.826 240.834 256.116C240.636 329.405 188.742 358.959 124.967 322.136C61.192 285.312 9.63566 196.054 9.85421 122.765C10.0529 49.4752 61.9469 19.9211 125.742 56.7446L125.722 56.7644Z",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.107 51.8789H134.086",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.723 56.7646C198.716 97.5605 271.074 229.263 228.041 309.206C222.954 317.766 215.782 325.155 207.18 330.18",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.191 18.0342C243.794 57.6184 299.224 153.59 299.006 232.401C298.887 271.568 285.059 299.096 262.767 312.066L214.668 339.991C213.714 340.548 212.801 341.124 211.827 341.62C205.608 344.997 198.834 347.221 191.84 348.294C169.092 351.332 149.542 345.771 124.966 332.126C49.9263 287.477 -9.91472 180.979 3.178 93.3495C6.95283 71.3428 17.6217 49.3758 37.5091 38.015",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.967 312.443C237.933 314.569 236.801 316.575 235.629 318.501C235.311 319.037 234.973 319.574 234.635 320.09C234.139 320.865 233.642 321.619 233.106 322.354C232.708 322.93 232.271 323.526 231.834 324.082C230.841 325.413 229.808 326.704 228.715 327.935C228.178 328.551 227.622 329.167 227.066 329.783L225.536 331.352C225.417 331.471 225.298 331.59 225.159 331.709C224.642 332.226 224.086 332.742 223.529 333.258C222.715 334.033 221.841 334.768 220.967 335.463C220.569 335.801 220.152 336.099 219.755 336.416C219.337 336.754 218.9 337.072 218.463 337.39C218.424 337.449 218.384 337.469 218.324 337.489C218.066 337.707 217.788 337.906 217.51 338.065C216.576 338.74 215.622 339.356 214.629 339.972C214.291 340.19 213.953 340.389 213.596 340.587",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.762 46.7539C126.835 47.3696 127.907 48.0052 128.96 48.6408C130.033 49.2763 131.086 49.9119 132.159 50.6269C132.815 51.0242 133.45 51.4413 134.106 51.8981C135.338 52.6925 136.55 53.5069 137.762 54.3411C138.338 54.7383 138.914 55.1554 139.47 55.5526C140.861 56.5258 142.232 57.5189 143.603 58.5517L145.967 60.3393C170.384 79.1681 193.232 105.584 211.212 135.416C211.907 136.608 212.623 137.82 213.338 139.031C234.894 175.855 248.96 217.524 249.517 256.314V256.513",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124.986 322.136C188.761 358.94 240.655 329.385 240.853 256.116C241.052 182.846 189.516 93.5681 125.721 56.7446C61.9263 19.941 10.0522 49.4951 9.85348 122.765C9.6548 196.054 61.1912 285.293 124.986 322.116M82.3899 41.4114C49.0522 45.5029 26.721 74.7591 26.6018 122.785C26.3833 196.054 77.9197 285.312 141.714 322.136C157.032 330.974 171.655 335.979 185.026 337.469M125.761 46.7542C194.363 86.3384 249.794 182.33 249.575 261.141C249.357 339.952 193.549 371.73 124.946 332.146C56.3435 292.522 0.893215 196.551 1.13163 117.74C1.35017 38.9287 57.1581 7.15008 125.761 46.7542Z",
    stroke: "#0000FF",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M183.477 220.623L154.629 184.773L160.788 181.178L189.655 217.028",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M183.477 220.623C187.927 226.145 189.437 233.593 186.854 237.227C186.636 237.525 186.417 237.764 186.179 238.002L185.861 238.26C185.861 238.26 185.702 238.379 185.622 238.439",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139.052 94.3232C137.284 95.2567 136.172 97.3621 136.172 100.381L135.953 180.185C135.953 183.999 137.701 188.567 140.582 192.162L174.099 233.792C175.569 235.619 177.158 237.009 178.748 237.903C181.311 239.393 183.834 239.631 185.622 238.419L191.582 234.964C192.119 234.646 192.635 234.189 193.033 233.613C195.635 229.978 194.105 222.53 189.675 217.009",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.828 111.145L154.629 184.773L160.788 181.178L161.006 107.57",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M151.707 91.4628C149.105 89.9533 146.76 89.8143 145.052 90.7875L138.873 94.3825C138.873 94.3825 138.992 94.303 139.072 94.303C139.191 94.2236 139.33 94.164 139.469 94.1044C139.588 94.0448 139.707 94.0249 139.847 93.9654C139.946 93.9256 140.065 93.9058 140.184 93.8859H140.224C140.86 93.7469 141.555 93.727 142.29 93.8462C142.807 93.9256 143.304 94.0647 143.86 94.2633C144.058 94.3427 144.237 94.4023 144.396 94.4818C144.774 94.6605 145.131 94.8393 145.509 95.0578",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.709 91.4629C156.855 94.4223 161.027 101.632 161.007 107.571",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.529 95.0576C150.675 98.017 154.847 105.227 154.827 111.146",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.53 95.0575C150.675 98.0368 154.848 105.247 154.828 111.165L154.609 184.773L183.457 220.623C187.907 226.144 189.417 233.592 186.834 237.227C185.086 239.67 181.947 239.769 178.728 237.922C177.159 237.009 175.549 235.618 174.079 233.791L140.583 192.161C137.702 188.586 135.934 184.018 135.934 180.185L136.152 100.4C136.152 94.4617 140.364 92.0783 145.51 95.0575H145.53Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.378 73.9443V74.0238L150.338 84.7094L156.537 81.1144V79.3467V79.3268V79.307",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.576 69.0384V68.959",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.418 63.8155V63.7949",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.416 63.8155V63.7949",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M144.199 58.9893V58.9688",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M144.178 68.9795V69.0987L144.139 81.115L150.337 84.7099L150.377 74.0244V73.9449",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.822 273.693L156.001 270.098L155.901 299.116L149.723 302.71L149.822 273.693Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M143.604 270.098L149.782 266.503L156.001 270.098L149.822 273.693L143.604 270.098Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M149.821 273.693L149.722 302.71L143.523 299.135L143.603 270.098L149.821 273.693Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M247.47 231.824L247.252 231.705",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M246.139 223.9L245.861 223.741",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M237.159 218.716L236.821 218.517L235.431 217.723L229.252 221.318L238.331 226.561L238.629 226.72H238.649",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.464 239.57L248.285 239.451",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M247.47 231.824L247.252 231.705",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M238.65 226.72H238.63L238.332 226.561L229.253 221.317L229.213 228.448L239.484 234.366L239.763 234.525",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7289 126.359L70.9077 122.764L70.8878 129.894L64.709 133.489L64.7289 126.359Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M39.457 111.761L45.6358 108.186L70.9074 122.764L64.7286 126.359L39.457 111.761Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7289 126.359L64.709 133.489L39.4375 118.911L39.4574 111.761L64.7289 126.359Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortTerm);
export default __webpack_public_path__ + "static/media/short_term.72e228ce9d4a4f35b3e62e19404c2d33.svg";
export { ForwardRef as ReactComponent };